import type { DeploymentManifest } from "@constructorfleet/offerings-sdk";

export const bhgCallDeployment: DeploymentManifest = {
  sdkVersionRange: "^0.1.0",
  minWorkerVersion: "0.1.0",
  migrationsRequired: false,
  requirements: ["canary-deployments"],
  topology: {
    workloads: [
      {
        id: "website",
        kind: "http",
        appPackage: "@constructorfleet/website",
        exposure: "public",
        scaling: { minReplicas: 2, maxReplicas: 4 },
        ports: [{ name: "http", port: 8787, protocol: "http", healthCheckPath: "/health" }],
        metrics: { path: "/metrics", portName: "http", exposure: "internal" },
        dependencyIds: ["platform-db", "secret-store"],
      },
      {
        id: "bhg-call-worker",
        kind: "worker",
        appPackage: "@constructorfleet/bhg-call",
        startScript: "worker:queue",
        dependencyIds: ["platform-db", "secret-store"],
      },
      {
        id: "processor-host",
        kind: "http",
        appPackage: "@constructorfleet/bhg-call",
        startScript: "worker:processor-host",
        exposure: "public",
        ports: [
          { name: "webhook", port: 8080, protocol: "http", healthCheckPath: "/health" },
          {
            name: "runtime",
            port: 8090,
            protocol: "http",
            healthCheckPath: "/internal/live-calls/health",
          },
        ],
        metrics: { path: "/metrics", portName: "runtime", exposure: "internal" },
        dependencyIds: ["platform-db", "secret-store"],
      },
    ],
    dependencies: [
      { id: "platform-db", kind: "postgres", lifecycle: "managed", required: true },
      { id: "secret-store", kind: "secret-store", lifecycle: "managed", required: true },
    ],
  },
};

export const deployment = bhgCallDeployment;
export default bhgCallDeployment;
